// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2UgeX","rowsWrapper":"style_rowsWrapper__2xQ6p","rowWrapper":"style_rowWrapper__VmmZU"};